import React from 'react';

import { C, HL, Lbl, Div } from './svgPrimitives';



export const levelCards2Visuals = {

  // -- AI visuals (Level 11 original cards) ----------------------------------

  ai_probability_insights: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="12" width="180" height="62" rx="4" fill="#1e293b" stroke="#6366F1" strokeWidth="1.5" />

      <text x="100" y="26" fill="#6366F1" fontSize="8" textAnchor="middle" fontFamily="sans-serif">What AI Actually Does</text>

      <text x="100" y="40" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Scans patterns across hundreds of stocks</text>

      <text x="100" y="52" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Scores setups by historical probability</text>

      <text x="100" y="64" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Shows you WHERE to look  -  not what to do</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">AI = pattern filter, not a crystal ball</text>

    </svg>

  ),

  ai_suggestion_validation: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="12" width="80" height="55" rx="3" fill="#1e293b" stroke="#6366F1" strokeWidth="1" />

      <text x="50" y="26" fill="#6366F1" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">AI says: BUY</text>

      <text x="50" y="40" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">RSI + Breakout</text>

      <text x="50" y="52" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">aligned</text>

      <line x1="90" y1="39" x2="110" y2="39" stroke="#f59e0b" strokeWidth="1.5" />

      <polygon points="110,39 104,36 104,42" fill="#f59e0b" />

      <rect x="110" y="12" width="80" height="55" rx="3" fill="#1e293b" stroke="#16C784" strokeWidth="1" />

      <text x="150" y="26" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">You validate</text>

      <text x="150" y="40" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Check chart</text>

      <text x="150" y="52" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Then decide</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">AI suggests  -  you validate  -  always</text>

    </svg>

  ),

  ai_trade_idea_flow: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="18" width="36" height="28" rx="3" fill="#1e293b" stroke="#6366F1" strokeWidth="1" />

      <text x="23" y="34" fill="#6366F1" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Scan</text>

      <line x1="41" y1="32" x2="55" y2="32" stroke="#94a3b8" strokeWidth="1.5" />

      <polygon points="55,32 49,29 49,35" fill="#94a3b8" />

      <rect x="55" y="18" width="36" height="28" rx="3" fill="#1e293b" stroke="#f59e0b" strokeWidth="1" />

      <text x="73" y="34" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Score</text>

      <line x1="91" y1="32" x2="105" y2="32" stroke="#94a3b8" strokeWidth="1.5" />

      <polygon points="105,32 99,29 99,35" fill="#94a3b8" />

      <rect x="105" y="18" width="36" height="28" rx="3" fill="#1e293b" stroke="#16C784" strokeWidth="1" />

      <text x="123" y="34" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Suggest</text>

      <line x1="141" y1="32" x2="155" y2="32" stroke="#94a3b8" strokeWidth="1.5" />

      <polygon points="155,32 149,29 149,35" fill="#94a3b8" />

      <rect x="155" y="18" width="40" height="28" rx="3" fill="#16C784" opacity="0.15" stroke="#16C784" strokeWidth="1" />

      <text x="175" y="30" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Your</text>

      <text x="175" y="40" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Call</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">AI builds the idea  -  you make the final call</text>

    </svg>

  ),

  ai_edge_validation: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <text x="50" y="12" fill="#6366F1" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">AI Analysis</text>

      <text x="50" y="28" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">RSI oversold OK</text>

      <text x="50" y="40" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Near support OK</text>

      <text x="50" y="52" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Volume low X</text>

      <text x="150" y="12" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Your Read</text>

      <text x="150" y="28" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Trend up OK</text>

      <text x="150" y="40" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Volume low X</text>

      <text x="150" y="52" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">-> Wait</text>

      <text x="100" y="72" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Both agree -> real edge</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">AI + your judgment = higher probability</text>

    </svg>

  ),

  ai_wrong_prediction: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="30" y="10" width="140" height="28" rx="3" fill="#1e293b" stroke="#6366F1" strokeWidth="1" />

      <text x="100" y="28" fill="#6366F1" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">AI: "High probability BUY"</text>

      <polyline points="30,48 60,42 90,38 120,52 150,68 180,82" fill="none" stroke="#ef4444" strokeWidth="2" />

      <text x="100" y="95" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Stock drops anyway</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">AI is probabilistic  -  losses are part of it</text>

    </svg>

  ),

  breakout: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="48" x2="195" y2="48" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="5,3" />

      <C x={8}  o={70} c={57} h={53} l={72} w={11} />

      <C x={22} o={57} c={63} h={50} l={65} w={11} />

      <C x={36} o={63} c={55} h={51} l={65} w={11} />

      <C x={50} o={55} c={60} h={49} l={62} w={11} />

      <C x={66} o={60} c={18} h={12} l={62} w={14} />

      <C x={83} o={26} c={8}  h={5}  l={28} w={11} />

      <polygon points="90,20 87,14 93,14" fill="#16C784" />

      <text x="140" y="30" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Breakout!</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Price breaks above resistance with momentum</text>

    </svg>

  ),



  // -- Scanner visuals (Level 70 archived cards) -----------------------------

  RSI_OVERSOLD: (

    <svg viewBox="0 0 200 110" className="w-full">

      <path d="M 20,75 A 80,80 0 0,1 180,75" fill="none" stroke="#1e293b" strokeWidth="10" strokeLinecap="round" />

      <path d="M 20,75 A 80,80 0 0,1 100,18" fill="none" stroke="#16C784" strokeWidth="8" strokeLinecap="round" opacity="0.4" />

      <path d="M 100,18 A 80,80 0 0,1 180,75" fill="none" stroke="#ef4444" strokeWidth="8" strokeLinecap="round" opacity="0.4" />

      <line x1="100" y1="75" x2="42" y2="42" stroke="#16C784" strokeWidth="2.5" strokeLinecap="round" />

      <circle cx="100" cy="75" r="5" fill="#16C784" />

      <text x="28" y="90" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">RSI &lt; 30</text>

      <text x="100" y="12" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Oversold</text>

      <text x="172" y="90" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">70+</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">RSI below 30  -  potential bounce zone</text>

    </svg>

  ),

  RSI_OVERBOUGHT: (

    <svg viewBox="0 0 200 110" className="w-full">

      <path d="M 20,75 A 80,80 0 0,1 180,75" fill="none" stroke="#1e293b" strokeWidth="10" strokeLinecap="round" />

      <path d="M 20,75 A 80,80 0 0,1 100,18" fill="none" stroke="#16C784" strokeWidth="8" strokeLinecap="round" opacity="0.4" />

      <path d="M 100,18 A 80,80 0 0,1 180,75" fill="none" stroke="#ef4444" strokeWidth="8" strokeLinecap="round" opacity="0.4" />

      <line x1="100" y1="75" x2="158" y2="42" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round" />

      <circle cx="100" cy="75" r="5" fill="#ef4444" />

      <text x="28" y="90" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">&lt;30</text>

      <text x="100" y="12" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Overbought</text>

      <text x="172" y="90" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">RSI &gt; 70</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">RSI above 70  -  potential reversal zone</text>

    </svg>

  ),

  RSI_CROSS_ABOVE_60: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="52" x2="195" y2="52" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="5,3" />

      <text x="190" y="48" fill="#f59e0b" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">RSI 60</text>

      <polyline points="10,85 40,78 70,65 100,55 130,42 160,28" fill="none" stroke="#6366F1" strokeWidth="2" />

      <circle cx="110" cy="52" r="5" fill="#16C784" />

      <text x="110" y="40" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Cross above 60</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">RSI crossing 60 = momentum building</text>

    </svg>

  ),

  RSI_CROSS_BELOW_40: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="58" x2="195" y2="58" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="5,3" />

      <text x="190" y="54" fill="#f59e0b" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">RSI 40</text>

      <polyline points="10,28 40,35 70,45 100,55 130,68 160,80" fill="none" stroke="#6366F1" strokeWidth="2" />

      <circle cx="105" cy="58" r="5" fill="#ef4444" />

      <text x="105" y="72" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Cross below 40</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">RSI crossing below 40 = weakness signal</text>

    </svg>

  ),

  MACD_BULLISH_CROSSOVER: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="58" x2="195" y2="58" stroke="#334155" strokeWidth="1" />

      <polyline points="10,78 50,70 90,60 130,44 170,28" fill="none" stroke="#6366F1" strokeWidth="1.5" />

      <polyline points="10,85 50,76 90,66 130,54 170,42" fill="none" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="4,2" />

      <circle cx="105" cy="55" r="5" fill="#16C784" />

      <text x="105" y="44" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">MACD crosses above</text>

      <text x="18" y="50" fill="#6366F1" fontSize="6.5" textAnchor="start" fontFamily="sans-serif">MACD</text>

      <text x="18" y="60" fill="#f59e0b" fontSize="6.5" textAnchor="start" fontFamily="sans-serif">Signal</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Bullish crossover = upward momentum</text>

    </svg>

  ),

  MACD_BEARISH_CROSSOVER: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="52" x2="195" y2="52" stroke="#334155" strokeWidth="1" />

      <polyline points="10,28 50,36 90,45 130,58 170,72" fill="none" stroke="#6366F1" strokeWidth="1.5" />

      <polyline points="10,22 50,30 90,38 130,50 170,62" fill="none" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="4,2" />

      <circle cx="118" cy="52" r="5" fill="#ef4444" />

      <text x="118" y="66" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">MACD crosses below</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Bearish crossover = downward momentum</text>

    </svg>

  ),

  MACD_HISTOGRAM_POSITIVE: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="68" x2="195" y2="68" stroke="#334155" strokeWidth="1" />

      <rect x="15" y="55" width="10" height="13" fill="#16C784" opacity="0.6" />

      <rect x="30" y="48" width="10" height="20" fill="#16C784" opacity="0.7" />

      <rect x="45" y="40" width="10" height="28" fill="#16C784" opacity="0.8" />

      <rect x="60" y="32" width="10" height="36" fill="#16C784" opacity="0.9" />

      <rect x="75" y="25" width="10" height="43" fill="#16C784" />

      <rect x="90" y="30" width="10" height="38" fill="#16C784" opacity="0.8" />

      <text x="150" y="40" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Histogram</text>

      <text x="150" y="52" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">above zero</text>

      <text x="150" y="64" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">= bullish</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Positive histogram = bulls in control</text>

    </svg>

  ),

  VOLUME_SPIKE: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="12" y="82" width="12" height="14" fill="#94a3b8" opacity="0.5" />

      <rect x="28" y="78" width="12" height="18" fill="#94a3b8" opacity="0.5" />

      <rect x="44" y="80" width="12" height="16" fill="#94a3b8" opacity="0.5" />

      <rect x="60" y="76" width="12" height="20" fill="#94a3b8" opacity="0.5" />

      <rect x="76" y="38" width="16" height="58" fill="#f59e0b" opacity="0.9" />

      <text x="84" y="33" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">3x avg!</text>

      <rect x="96" y="74" width="12" height="22" fill="#94a3b8" opacity="0.5" />

      <rect x="112" y="78" width="12" height="18" fill="#94a3b8" opacity="0.5" />

      <text x="160" y="50" fill="#f59e0b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Volume spike</text>

      <text x="160" y="62" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">= big players</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Unusual volume signals institutional activity</text>

    </svg>

  ),

  BREAKOUT_VOLUME_SPIKE: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="45" x2="195" y2="45" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="5,3" />

      <C x={8}  o={68} c={55} h={52} l={70} w={11} />

      <C x={22} o={55} c={62} h={48} l={64} w={11} />

      <C x={36} o={62} c={52} h={48} l={64} w={11} />

      <C x={50} o={52} c={58} h={46} l={60} w={11} />

      <C x={66} o={58} c={16} h={10} l={60} w={14} />

      <rect x="66" y="80" width="14" height="22" fill="#16C784" opacity="0.85" />

      <text x="73" y="76" fill="#16C784" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Vol^</text>

      <text x="140" y="30" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Confirmed!</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Breakout + volume = high conviction signal</text>

    </svg>

  ),

  GOLDEN_CROSS: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,80 50,68 90,52 130,35 170,18" fill="none" stroke="#16C784" strokeWidth="2" />

      <polyline points="10,90 50,80 90,65 130,50 170,35" fill="none" stroke="#f59e0b" strokeWidth="2" strokeDasharray="4,2" />

      <circle cx="105" cy="54" r="6" fill="#16C784" opacity="0.3" stroke="#16C784" strokeWidth="1.5" />

      <text x="105" y="42" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Golden Cross</text>

      <text x="18" y="55" fill="#16C784" fontSize="6.5" textAnchor="start" fontFamily="sans-serif">SMA50</text>

      <text x="18" y="68" fill="#f59e0b" fontSize="6.5" textAnchor="start" fontFamily="sans-serif">SMA200</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">SMA50 crosses above SMA200 = long-term bullish</text>

    </svg>

  ),

  DEATH_CROSS: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,25 50,35 90,50 130,65 170,80" fill="none" stroke="#ef4444" strokeWidth="2" />

      <polyline points="10,15 50,25 90,38 130,52 170,65" fill="none" stroke="#f59e0b" strokeWidth="2" strokeDasharray="4,2" />

      <circle cx="108" cy="50" r="6" fill="#ef4444" opacity="0.3" stroke="#ef4444" strokeWidth="1.5" />

      <text x="108" y="38" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Death Cross</text>

      <text x="18" y="42" fill="#ef4444" fontSize="6.5" textAnchor="start" fontFamily="sans-serif">SMA50</text>

      <text x="18" y="30" fill="#f59e0b" fontSize="6.5" textAnchor="start" fontFamily="sans-serif">SMA200</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">SMA50 crosses below SMA200 = long-term bearish</text>

    </svg>

  ),

  PRICE_ABOVE_SMA20: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,72 40,65 70,55 100,45 130,35 160,25 185,18" fill="none" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="5,2" />

      <text x="185" y="14" fill="#f59e0b" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">SMA 20</text>

      <C x={15} o={52} c={38} h={34} l={54} w={13} />

      <C x={45} o={44} c={28} h={24} l={46} w={13} />

      <C x={75} o={34} c={18} h={14} l={36} w={13} />

      <C x={105} o={24} c={10} h={6}  l={26} w={13} />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Price above SMA20 = short-term bullish</text>

    </svg>

  ),

  PRICE_ABOVE_SMA50: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,78 50,68 90,55 130,40 170,25" fill="none" stroke="#f59e0b" strokeWidth="2" strokeDasharray="5,2" />

      <text x="170" y="20" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">SMA 50</text>

      <C x={20} o={58} c={42} h={38} l={60} w={13} />

      <C x={55} o={44} c={28} h={24} l={46} w={13} />

      <C x={90} o={34} c={18} h={14} l={36} w={13} />

      <text x="155" y="50" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Price above</text>

      <text x="155" y="62" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">SMA50 OK</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Price above SMA50 = medium-term bullish</text>

    </svg>

  ),

  PRICE_ABOVE_SMA200: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,82 50,72 90,60 130,46 170,30" fill="none" stroke="#f59e0b" strokeWidth="2" strokeDasharray="5,2" />

      <text x="170" y="25" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">SMA 200</text>

      <C x={20} o={62} c={46} h={42} l={64} w={13} />

      <C x={55} o={46} c={30} h={26} l={48} w={13} />

      <text x="140" y="55" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Above SMA200</text>

      <text x="140" y="67" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">= long-term bull</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Above SMA200 = long-term uptrend confirmed</text>

    </svg>

  ),

  PRICE_BELOW_SMA20: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,30 50,38 90,48 130,58 170,70" fill="none" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="5,2" />

      <text x="170" y="66" fill="#f59e0b" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">SMA 20</text>

      <C x={20} o={52} c={68} h={50} l={70} w={13} />

      <C x={55} o={62} c={76} h={60} l={78} w={13} />

      <C x={90} o={72} c={86} h={70} l={88} w={13} />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Price below SMA20 = short-term bearish</text>

    </svg>

  ),

  BREAKOUT_20D_HIGH: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="38" x2="195" y2="38" stroke="#16C784" strokeWidth="1.5" strokeDasharray="5,3" />

      <text x="190" y="34" fill="#16C784" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">20D High</text>

      <C x={8}  o={65} c={52} h={48} l={67} w={11} />

      <C x={22} o={52} c={58} h={46} l={60} w={11} />

      <C x={36} o={58} c={50} h={46} l={60} w={11} />

      <C x={50} o={50} c={55} h={44} l={57} w={11} />

      <C x={66} o={55} c={22} h={15} l={57} w={14} />

      <C x={83} o={28} c={8}  h={5}  l={30} w={11} />

      <text x="140" y="28" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">New 20D High!</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Breaking 20-day high = fresh momentum</text>

    </svg>

  ),

  BREAKDOWN_20D_LOW: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="68" x2="195" y2="68" stroke="#ef4444" strokeWidth="1.5" strokeDasharray="5,3" />

      <text x="190" y="64" fill="#ef4444" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">20D Low</text>

      <C x={8}  o={38} c={52} h={36} l={54} w={11} />

      <C x={22} o={52} c={44} h={36} l={54} w={11} />

      <C x={36} o={44} c={50} h={38} l={52} w={11} />

      <C x={50} o={50} c={46} h={40} l={52} w={11} />

      <C x={66} o={46} c={82} h={44} l={85} w={14} />

      <C x={83} o={78} c={92} h={75} l={95} w={11} />

      <text x="140" y="90" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">New 20D Low!</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Breaking 20-day low = fresh weakness</text>

    </svg>

  ),

  NEAR_52W_HIGH: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="18" x2="195" y2="18" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="5,3" />

      <text x="190" y="14" fill="#f59e0b" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">52W High</text>

      <polyline points="10,88 40,72 70,55 100,38 130,24 160,20 185,19" fill="none" stroke="#16C784" strokeWidth="2" />

      <circle cx="170" cy="19" r="5" fill="#f59e0b" />

      <text x="120" y="40" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Near 52W High</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Close to 52-week high = sustained strength</text>

    </svg>

  ),

  NEAR_52W_LOW: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="92" x2="195" y2="92" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="5,3" />

      <text x="190" y="88" fill="#f59e0b" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">52W Low</text>

      <polyline points="10,20 40,35 70,52 100,68 130,82 160,90 185,92" fill="none" stroke="#ef4444" strokeWidth="2" />

      <circle cx="170" cy="91" r="5" fill="#f59e0b" />

      <text x="100" y="65" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Near 52W Low</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Close to 52-week low = sustained weakness</text>

    </svg>

  ),

  INSIDE_DAY: (

    <svg viewBox="0 0 200 110" className="w-full">

      <C x={55}  o={72} c={28} h={18} l={78} w={28} />

      <C x={100} o={58} c={44} h={35} l={62} w={20} />

      <text x="68" y="14" fill="#94a3b8" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Mother bar</text>

      <text x="110" y="82" fill="#f59e0b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Inside bar</text>

      <line x1="55"  y1="18" x2="83"  y2="18" stroke="#94a3b8" strokeWidth="1" strokeDasharray="2,2" />

      <line x1="55"  y1="78" x2="83"  y2="78" stroke="#94a3b8" strokeWidth="1" strokeDasharray="2,2" />

      <line x1="100" y1="35" x2="120" y2="35" stroke="#f59e0b" strokeWidth="1" strokeDasharray="2,2" />

      <line x1="100" y1="62" x2="120" y2="62" stroke="#f59e0b" strokeWidth="1" strokeDasharray="2,2" />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Inside day = compression before breakout</text>

    </svg>

  ),

  BULLISH_ENGULFING: (

    <svg viewBox="0 0 200 110" className="w-full">

      <C x={62}  o={45} c={68} h={42} l={70} w={22} />

      <C x={90}  o={72} c={28} h={22} l={75} w={30} />

      <text x="72" y="38" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Bear</text>

      <text x="105" y="22" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Bull engulfs</text>

      <polygon points="130,32 127,26 133,26" fill="#16C784" />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Bull candle engulfs prior bear = reversal signal</text>

    </svg>

  ),

  ADX_STRONG_TREND: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="62" x2="195" y2="62" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="5,3" />

      <text x="190" y="58" fill="#f59e0b" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">ADX 25</text>

      <polyline points="10,90 40,80 70,68 100,52 130,38 160,22" fill="none" stroke="#6366F1" strokeWidth="2" />

      <circle cx="115" cy="48" r="5" fill="#16C784" />

      <text x="115" y="36" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">ADX &gt; 25</text>

      <text x="40" y="50" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Weak trend</text>

      <text x="155" y="35" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Strong!</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">ADX above 25 = trend has real strength</text>

    </svg>

  ),

  CONSOLIDATION_BREAKOUT: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="38" x2="195" y2="38" stroke="#16C784" strokeWidth="1" strokeDasharray="4,3" />

      <line x1="5" y1="65" x2="195" y2="65" stroke="#ef4444" strokeWidth="1" strokeDasharray="4,3" />

      <C x={8}  o={60} c={44} h={40} l={62} w={11} />

      <C x={22} o={44} c={52} h={40} l={54} w={11} />

      <C x={36} o={52} c={46} h={40} l={54} w={11} />

      <C x={50} o={46} c={50} h={40} l={52} w={11} />

      <C x={64} o={50} c={44} h={40} l={52} w={11} />

      <C x={80} o={44} c={14} h={8}  l={46} w={14} />

      <C x={97} o={22} c={5}  h={3}  l={24} w={11} />

      <text x="145" y="25" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Breakout!</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Consolidation ends  -  breakout begins</text>

    </svg>

  ),

  CLOSE_ABOVE_PREV_HIGH: (

    <svg viewBox="0 0 200 110" className="w-full">

      <C x={40} o={55} c={72} h={50} l={74} w={18} />

      <line x1="40" y1="50" x2="130" y2="50" stroke="#16C784" strokeWidth="1.5" strokeDasharray="4,3" />

      <text x="38" y="46" fill="#16C784" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Prev High</text>

      <C x={80} o={52} c={35} h={30} l={55} w={18} />

      <text x="89" y="28" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Closed above!</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Close above prior high = bullish continuation</text>

    </svg>

  ),

  CLOSE_BELOW_PREV_LOW: (

    <svg viewBox="0 0 200 110" className="w-full">

      <C x={40} o={38} c={55} h={36} l={58} w={18} />

      <line x1="40" y1="58" x2="130" y2="58" stroke="#ef4444" strokeWidth="1.5" strokeDasharray="4,3" />

      <text x="38" y="54" fill="#ef4444" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Prev Low</text>

      <C x={80} o={54} c={72} h={52} l={75} w={18} />

      <text x="89" y="88" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Closed below!</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Close below prior low = bearish continuation</text>

    </svg>

  ),



  // -- Level 8: Chart Patterns -----------------------------------------------



  l8_c801_pattern_is: (

    <svg viewBox="0 0 200 110" className="w-full">

      <C x={8}  o={72} c={55} h={50} l={74} w={12} />

      <C x={23} o={55} c={65} h={50} l={67} w={12} />

      <C x={38} o={65} c={52} h={48} l={67} w={12} />

      <C x={53} o={52} c={60} h={48} l={62} w={12} />

      <C x={68} o={60} c={48} h={44} l={62} w={12} />

      <text x="55" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Price action</text>

      <text x="130" y="38" fill="#f59e0b" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Pattern =</text>

      <text x="130" y="50" fill="#f59e0b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">repeated crowd</text>

      <text x="130" y="62" fill="#f59e0b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">behavior</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Patterns = human behavior repeating itself</text>

    </svg>

  ),



  l8_c802_double_bottom: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,25 40,65 60,82 80,65 100,28 130,68 150,82 170,65 190,25" fill="none" stroke="#16C784" strokeWidth="2" />

      <line x1="5" y1="28" x2="195" y2="28" stroke="#16C784" strokeWidth="1" strokeDasharray="4,3" />

      <text x="190" y="24" fill="#16C784" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Neckline</text>

      <circle cx="60" cy="82" r="4" fill="#16C784" opacity="0.5" />

      <circle cx="150" cy="82" r="4" fill="#16C784" opacity="0.5" />

      <text x="105" y="96" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Two equal lows</text>

      <polygon points="190,25 186,32 194,32" fill="#16C784" />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Double bottom = bullish reversal signal</text>

    </svg>

  ),



  l8_c803_double_top: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,85 40,45 60,28 80,45 100,82 130,42 150,28 170,45 190,85" fill="none" stroke="#ef4444" strokeWidth="2" />

      <line x1="5" y1="82" x2="195" y2="82" stroke="#ef4444" strokeWidth="1" strokeDasharray="4,3" />

      <text x="190" y="92" fill="#ef4444" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Neckline</text>

      <circle cx="60" cy="28" r="4" fill="#ef4444" opacity="0.5" />

      <circle cx="150" cy="28" r="4" fill="#ef4444" opacity="0.5" />

      <text x="105" y="22" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Two equal highs</text>

      <polygon points="190,85 186,78 194,78" fill="#ef4444" />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Double top = bearish reversal signal</text>

    </svg>

  ),



  l8_c804_head_shoulders: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,82 30,55 50,42 70,55 100,18 130,55 150,42 170,55 190,82" fill="none" stroke="#ef4444" strokeWidth="2" />

      <line x1="5" y1="58" x2="195" y2="58" stroke="#f59e0b" strokeWidth="1" strokeDasharray="4,3" />

      <text x="50" y="38" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">L shoulder</text>

      <text x="100" y="14" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Head</text>

      <text x="150" y="38" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">R shoulder</text>

      <text x="190" y="54" fill="#f59e0b" fontSize="6" textAnchor="end" fontFamily="sans-serif">Neckline</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">H&S = top reversal, break neckline to confirm</text>

    </svg>

  ),



  l8_c805_inv_head_shoulders: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,25 30,55 50,68 70,55 100,92 130,55 150,68 170,55 190,25" fill="none" stroke="#16C784" strokeWidth="2" />

      <line x1="5" y1="52" x2="195" y2="52" stroke="#f59e0b" strokeWidth="1" strokeDasharray="4,3" />

      <text x="50" y="75" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">L shoulder</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Inv H&S = bottom reversal, bullish breakout</text>

      <text x="150" y="75" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">R shoulder</text>

      <polygon points="190,25 186,32 194,32" fill="#16C784" />

    </svg>

  ),



  l8_c806_asc_triangle: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="10" y1="28" x2="175" y2="28" stroke="#16C784" strokeWidth="1.5" strokeDasharray="5,3" />

      <polyline points="10,88 55,68 100,50 145,36 175,28" fill="none" stroke="#16C784" strokeWidth="1.5" />

      <C x={12} o={72} c={50} h={40} l={74} w={12} />

      <C x={28} o={50} c={60} h={40} l={62} w={12} />

      <C x={44} o={60} c={48} h={38} l={62} w={12} />

      <C x={60} o={48} c={56} h={36} l={58} w={12} />

      <C x={76} o={38} c={18} h={14} l={40} w={14} />

      <polygon points="192,18 188,26 196,26" fill="#16C784" />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Ascending triangle = bullish breakout pattern</text>

    </svg>

  ),



  l8_c807_desc_triangle: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="10" y1="82" x2="175" y2="82" stroke="#ef4444" strokeWidth="1.5" strokeDasharray="5,3" />

      <polyline points="10,22 55,42 100,58 145,70 175,82" fill="none" stroke="#ef4444" strokeWidth="1.5" />

      <C x={12} o={38} c={58} h={35} l={60} w={12} />

      <C x={28} o={58} c={46} h={38} l={60} w={12} />

      <C x={44} o={46} c={56} h={42} l={58} w={12} />

      <C x={60} o={56} c={62} h={50} l={64} w={12} />

      <C x={76} o={60} c={88} h={58} l={90} w={14} />

      <polygon points="192,92 188,84 196,84" fill="#ef4444" />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Descending triangle = bearish breakdown pattern</text>

    </svg>

  ),



  l8_c808_bull_flag: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,88 35,55 55,25" fill="none" stroke="#16C784" strokeWidth="2.5" />

      <text x="32" y="22" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Pole ^</text>

      <C x={57} o={32} c={38} h={28} l={40} w={11} />

      <C x={71} o={38} c={44} h={32} l={46} w={11} />

      <C x={85} o={44} c={38} h={34} l={46} w={11} />

      <C x={99} o={38} c={44} h={34} l={46} w={11} />

      <text x="85" y="58" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Flag</text>

      <polyline points="113,40 140,18 170,8" fill="none" stroke="#16C784" strokeWidth="2" />

      <polygon points="170,8 164,14 172,12" fill="#16C784" />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Bull flag = pause in uptrend, continuation expected</text>

    </svg>

  ),



  l8_c809_bear_flag: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,18 35,52 55,82" fill="none" stroke="#ef4444" strokeWidth="2.5" />

      <text x="32" y="95" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Pole v</text>

      <C x={57} o={72} c={66} h={64} l={74} w={11} />

      <C x={71} o={66} c={60} h={58} l={68} w={11} />

      <C x={85} o={60} c={66} h={58} l={68} w={11} />

      <C x={99} o={66} c={60} h={58} l={68} w={11} />

      <text x="85" y="55" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Flag</text>

      <polyline points="113,62 140,80 165,98" fill="none" stroke="#ef4444" strokeWidth="2" />

      <polygon points="165,98 160,90 168,92" fill="#ef4444" />

      <text x="100" y="108" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Bear flag = pause in downtrend, continuation expected</text>

    </svg>

  ),



  l8_c810_support_bounce: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="75" x2="195" y2="75" stroke="#16C784" strokeWidth="1.5" strokeDasharray="5,3" />

      <text x="190" y="71" fill="#16C784" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Support</text>

      <polyline points="10,30 35,50 60,72 75,75" fill="none" stroke="#94a3b8" strokeWidth="1.5" />

      <circle cx="75" cy="75" r="4" fill="#16C784" />

      <polyline points="75,75 100,55 130,35 160,18" fill="none" stroke="#16C784" strokeWidth="2" />

      <polygon points="160,18 155,25 163,23" fill="#16C784" />

      <text x="75" y="90" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Bounce!</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Price touches support and bounces up</text>

    </svg>

  ),



  l8_c811_resistance_reject: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="28" x2="195" y2="28" stroke="#ef4444" strokeWidth="1.5" strokeDasharray="5,3" />

      <text x="190" y="24" fill="#ef4444" fontSize="6.5" textAnchor="end" fontFamily="sans-serif">Resistance</text>

      <polyline points="10,88 35,68 60,48 75,28" fill="none" stroke="#94a3b8" strokeWidth="1.5" />

      <circle cx="75" cy="28" r="4" fill="#ef4444" />

      <polyline points="75,28 100,48 130,65 160,82" fill="none" stroke="#ef4444" strokeWidth="2" />

      <polygon points="160,82 154,76 162,78" fill="#ef4444" />

      <text x="75" y="18" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Rejected!</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Price hits resistance and gets pushed back down</text>

    </svg>

  ),



  l8_c812_patterns_fail: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="45" x2="195" y2="45" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="5,3" />

      <C x={8}  o={68} c={55} h={52} l={70} w={11} />

      <C x={22} o={55} c={62} h={48} l={64} w={11} />

      <C x={36} o={62} c={52} h={48} l={64} w={11} />

      <C x={50} o={52} c={28} h={22} l={54} w={14} />

      <C x={68} o={42} c={55} h={51} l={57} w={11} />

      <C x={82} o={55} c={65} h={61} l={67} w={11} />

      <C x={96} o={65} c={72} h={68} l={74} w={11} />

      <text x="55" y="15" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Breaks out...</text>

      <text x="100" y="92" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">...then fails back inside</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Patterns fail  -  always use a stop loss</text>

    </svg>

  ),



  // -- Level 10: Practice & Behavior ----------------------------------------



  l10_c1001_practice_decision: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <text x="50" y="12" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Watching</text>

      <text x="50" y="28" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">"I see a breakout"</text>

      <text x="50" y="40" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">"Looks good"</text>

      <text x="50" y="52" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">No action</text>

      <text x="50" y="64" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">No learning</text>

      <text x="150" y="12" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Deciding</text>

      <text x="150" y="28" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">"Entry: ₹00"</text>

      <text x="150" y="40" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">"SL: ₹4"</text>

      <text x="150" y="52" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">"Target: ₹12"</text>

      <text x="150" y="64" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Real practice</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Practice = making decisions, not just watching</text>

    </svg>

  ),



  l10_c1002_trade_structure: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="12" width="180" height="65" rx="4" fill="#1e293b" stroke="#334155" strokeWidth="1" />

      <text x="100" y="26" fill="#f59e0b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Complete Trade Structure</text>

      <text x="18" y="40" fill="#16C784" fontSize="7" textAnchor="start" fontFamily="sans-serif">Entry: ₹00 (breakout above resistance)</text>

      <text x="18" y="52" fill="#ef4444" fontSize="7" textAnchor="start" fontFamily="sans-serif">Stop Loss: ₹92 (below breakout level)</text>

      <text x="18" y="64" fill="#16C784" fontSize="7" textAnchor="start" fontFamily="sans-serif">Target: ₹24 (1:3 risk-reward)</text>

      <text x="18" y="72" fill="#94a3b8" fontSize="6.5" textAnchor="start" fontFamily="sans-serif">Size: ₹00 / ₹ = 100 shares</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">No structure = confusion under pressure</text>

    </svg>

  ),



  l10_c1003_consistency: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,75 35,65 60,68 85,58 110,62 135,52 160,55 185,45" fill="none" stroke="#16C784" strokeWidth="2" />

      <C x={12} o={72} c={58} h={54} l={74} w={11} />

      <C x={26} o={58} c={65} h={52} l={67} w={11} />

      <C x={40} o={65} c={55} h={51} l={67} w={11} />

      <text x="100" y="38" fill="#16C784" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Consistent process</text>

      <text x="100" y="50" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">even with losses</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Consistency of process -> consistency of results</text>

    </svg>

  ),



  l10_c1004_quality_over_qty: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="8" y="18" width="82" height="55" rx="4" fill="#1e293b" stroke="#ef4444" strokeWidth="1" />

      <text x="49" y="32" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">10 trades/day</text>

      <text x="49" y="46" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">6 forced setups</text>

      <text x="49" y="58" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Net: -₹,200</text>

      <rect x="110" y="18" width="82" height="55" rx="4" fill="#1e293b" stroke="#16C784" strokeWidth="1" />

      <text x="151" y="32" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">2 trades/day</text>

      <text x="151" y="46" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">2 clean setups</text>

      <text x="151" y="58" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Net: +₹,400</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Fewer better trades beats more bad ones</text>

    </svg>

  ),



  l10_c1005_no_trade_zone: (

    <svg viewBox="0 0 200 110" className="w-full">

      <line x1="5" y1="25" x2="195" y2="25" stroke="#ef4444" strokeWidth="1" strokeDasharray="4,3" />

      <line x1="5" y1="75" x2="195" y2="75" stroke="#16C784" strokeWidth="1" strokeDasharray="4,3" />

      <rect x="5" y="25" width="190" height="50" fill="#f59e0b" opacity="0.05" />

      <text x="100" y="48" fill="#f59e0b" fontSize="8" textAnchor="middle" fontFamily="sans-serif">No Trade Zone</text>

      <text x="100" y="60" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Between support & resistance</text>

      <text x="100" y="18" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Sell zone</text>

      <text x="100" y="90" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Buy zone</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Mid-range = low edge = no trade</text>

    </svg>

  ),



  l10_c1006_predictable_mistakes: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="10" width="180" height="68" rx="4" fill="#1e293b" stroke="#334155" strokeWidth="1" />

      <text x="100" y="24" fill="#f59e0b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Your Mistake Pattern:</text>

      <text x="18" y="38" fill="#ef4444" fontSize="7" textAnchor="start" fontFamily="sans-serif">X Move SL when trade goes against you</text>

      <text x="18" y="50" fill="#ef4444" fontSize="7" textAnchor="start" fontFamily="sans-serif">X Exit winners too early</text>

      <text x="18" y="62" fill="#ef4444" fontSize="7" textAnchor="start" fontFamily="sans-serif">X Overtrade after a loss</text>

      <text x="18" y="72" fill="#16C784" fontSize="7" textAnchor="start" fontFamily="sans-serif">-> Identify -> Fix -> Track</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Your mistakes are predictable  -  fix them systematically</text>

    </svg>

  ),



  l10_c1007_emotional_cycle: (

    <svg viewBox="0 0 200 110" className="w-full">

      <circle cx="100" cy="52" r="38" fill="none" stroke="#334155" strokeWidth="1" />

      <text x="100" y="18" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Enter -> Excited</text>

      <text x="168" y="55" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Dip -> Fear</text>

      <text x="100" y="92" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Falling -> Hope</text>

      <text x="32" y="55" fill="#6366F1" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Big loss -> Panic</text>

      <text x="100" y="54" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Break the cycle</text>

      <text x="100" y="64" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">with a plan</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Emotions are predictable  -  plan beats them</text>

    </svg>

  ),



  l10_c1008_small_vs_big_loss: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <text x="50" y="12" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Small loss</text>

      <rect x="30" y="55" width="40" height="22" rx="2" fill="#ef4444" opacity="0.6" />

      <text x="50" y="70" fill="#fff" fontSize="7" textAnchor="middle" fontFamily="sans-serif">-₹00</text>

      <text x="50" y="90" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Recoverable</text>

      <text x="150" y="12" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Big loss</text>

      <rect x="120" y="22" width="60" height="55" rx="2" fill="#ef4444" opacity="0.8" />

      <text x="150" y="54" fill="#fff" fontSize="7" textAnchor="middle" fontFamily="sans-serif">-₹,000</text>

      <text x="150" y="90" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Devastating</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Take the small loss  -  avoid the big one</text>

    </svg>

  ),



  l10_c1009_missing_vs_chasing: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <text x="50" y="12" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Miss the trade</text>

      <polyline points="8,82 30,65 52,45 72,28" fill="none" stroke="#16C784" strokeWidth="2" />

      <circle cx="72" cy="28" r="4" fill="#16C784" />

      <text x="50" y="96" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Capital safe OK</text>

      <text x="50" y="105" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Next setup coming</text>

      <text x="150" y="12" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Chase the trade</text>

      <polyline points="108,82 130,65 152,45 172,28" fill="none" stroke="#16C784" strokeWidth="1.5" />

      <circle cx="172" cy="28" r="4" fill="#16C784" />

      <circle cx="185" cy="35" r="4" fill="#ef4444" />

      <text x="185" y="22" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Buy here</text>

      <polyline points="185,35 193,55" fill="none" stroke="#ef4444" strokeWidth="1.5" />

      <text x="150" y="105" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Bought at peak -> loss</text>

    </svg>

  ),



  l10_c1010_realtime_vs_past: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <text x="50" y="12" fill="#6366F1" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Hindsight</text>

      <C x={8}  o={75} c={55} h={50} l={77} w={11} />

      <C x={22} o={55} c={65} h={50} l={67} w={11} />

      <C x={36} o={65} c={40} h={35} l={67} w={11} />

      <C x={50} o={40} c={20} h={15} l={42} w={11} />

      <text x="38" y="100" fill="#6366F1" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">"Obvious in hindsight"</text>

      <text x="150" y="12" fill="#f59e0b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Real-time</text>

      <C x={108} o={68} c={52} h={46} l={70} w={11} />

      <C x={122} o={52} c={60} h={46} l={62} w={11} />

      <rect x="138" y="40" width="50" height="28" rx="3" fill="#1e293b" stroke="#f59e0b" strokeWidth="1" />

      <text x="163" y="54" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">What now?</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Real-time is harder  -  practice in real conditions</text>

    </svg>

  ),



  l10_c1011_same_setup: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <text x="50" y="12" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Monday</text>

      <C x={15} o={62} c={22} h={16} l={64} w={14} />

      <C x={32} o={30} c={10} h={6}  l={32} w={11} />

      <text x="34" y="100" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">+₹,200 OK</text>

      <text x="150" y="12" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Friday</text>

      <C x={115} o={62} c={22} h={16} l={64} w={14} />

      <C x={132} o={30} c={48} h={28} l={52} w={11} />

      <C x={146} o={48} c={65} h={44} l={67} w={11} />

      <text x="142" y="100" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">-₹00 X</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Same setup, different result  -  that's normal</text>

    </svg>

  ),



  l10_c1012_responsibility: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <text x="50" y="12" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Market's role</text>

      <text x="50" y="30" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Price moves</text>

      <text x="50" y="42" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">randomly</text>

      <text x="50" y="54" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">sometimes</text>

      <text x="50" y="66" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Not your fault</text>

      <text x="150" y="12" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Your role</text>

      <text x="150" y="30" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Follow the plan</text>

      <text x="150" y="42" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Risk correctly</text>

      <text x="150" y="54" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Execute well</text>

      <text x="150" y="66" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Your responsibility</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Control what you can  -  let go of what you can't</text>

    </svg>

  ),



  // -- Level 12: Backtesting -------------------------------------------------



  l12_c1201_what_backtest: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="12" width="180" height="62" rx="4" fill="#1e293b" stroke="#6366F1" strokeWidth="1.5" />

      <text x="100" y="26" fill="#6366F1" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Backtesting</text>

      <text x="100" y="40" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Apply your rules to past data</text>

      <text x="100" y="52" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">See how they would have performed</text>

      <text x="100" y="64" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Before risking real capital</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Test the idea before trusting it with money</text>

    </svg>

  ),



  l12_c1202_idea_vs_reality: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <text x="50" y="12" fill="#6366F1" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">The Idea</text>

      <text x="50" y="28" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">"Buy RSI &lt; 30"</text>

      <text x="50" y="40" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Sounds great!</text>

      <text x="50" y="52" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Always bounces</text>

      <text x="150" y="12" fill="#f59e0b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">The Reality</text>

      <text x="150" y="28" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">100 trades tested</text>

      <text x="150" y="40" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">42 wins</text>

      <text x="150" y="52" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">58 losses</text>

      <text x="150" y="64" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Net: -₹,200</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Ideas feel good  -  data tells the truth</text>

    </svg>

  ),



  l12_c1203_one_example: (

    <svg viewBox="0 0 200 110" className="w-full">

      <C x={70} o={65} c={18} h={12} l={67} w={20} />

      <text x="80" y="10" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">One great trade</text>

      <text x="100" y="55" fill="#f59e0b" fontSize="24" textAnchor="middle" fontFamily="sans-serif">!=</text>

      <rect x="20" y="68" width="160" height="22" rx="3" fill="#1e293b" stroke="#334155" strokeWidth="1" />

      <text x="100" y="83" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Need 50-100 trades to know if edge is real</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">One example proves nothing  -  sample size matters</text>

    </svg>

  ),



  l12_c1204_backtest_shows: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="10" width="190" height="68" rx="4" fill="#1e293b" stroke="#334155" strokeWidth="1" />

      <text x="100" y="24" fill="#f59e0b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Backtest Results:</text>

      <text x="18" y="38" fill="#16C784" fontSize="7" textAnchor="start" fontFamily="sans-serif">Win rate: 48%</text>

      <text x="18" y="50" fill="#16C784" fontSize="7" textAnchor="start" fontFamily="sans-serif">Avg win: ₹,400 | Avg loss: ₹00</text>

      <text x="18" y="62" fill="#16C784" fontSize="7" textAnchor="start" fontFamily="sans-serif">Net expectancy: +₹80 per trade</text>

      <text x="18" y="72" fill="#94a3b8" fontSize="6.5" textAnchor="start" fontFamily="sans-serif">Max drawdown: -₹,200</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Backtest reveals the real numbers  -  not feelings</text>

    </svg>

  ),



  l12_c1205_rr_visible: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="55" width="35" height="32" rx="2" fill="#ef4444" opacity="0.7" />

      <text x="27" y="74" fill="#fff" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Loss</text>

      <text x="27" y="84" fill="#fff" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">₹00</text>

      <rect x="55" y="22" width="35" height="65" rx="2" fill="#16C784" opacity="0.7" />

      <text x="72" y="58" fill="#fff" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Win</text>

      <text x="72" y="68" fill="#fff" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">₹,400</text>

      <text x="140" y="40" fill="#f59e0b" fontSize="20" textAnchor="middle" fontFamily="sans-serif">1:2.3</text>

      <text x="140" y="58" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">R:R ratio</text>

      <text x="140" y="70" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">visible in data</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Backtesting makes risk-reward concrete</text>

    </svg>

  ),



  l12_c1206_looks_good_isnt: (

    <svg viewBox="0 0 200 110" className="w-full">

      <C x={8}  o={72} c={28} h={22} l={74} w={13} />

      <C x={24} o={35} c={10} h={6}  l={37} w={11} />

      <C x={38} o={65} c={22} h={16} l={67} w={13} />

      <C x={54} o={30} c={8}  h={4}  l={32} w={11} />

      <text x="40" y="100" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Win rate: 80%!</text>

      <line x1="100" y1="5" x2="100" y2="105" stroke="#334155" strokeWidth="1" strokeDasharray="3,2" />

      <rect x="108" y="18" width="84" height="50" rx="3" fill="#1e293b" stroke="#ef4444" strokeWidth="1" />

      <text x="150" y="32" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">But avg loss:</text>

      <text x="150" y="44" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">₹,000</text>

      <text x="150" y="56" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Avg win: ₹00</text>

      <text x="150" y="68" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Net: losing!</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">High win rate + bad R:R = still losing money</text>

    </svg>

  ),



  l12_c1207_conditions_change: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="10,80 40,55 70,35 90,20" fill="none" stroke="#16C784" strokeWidth="2" />

      <text x="50" y="15" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Bull market</text>

      <line x1="90" y1="5" x2="90" y2="105" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="4,2" />

      <text x="90" y="105" fill="#f59e0b" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Market change</text>

      <polyline points="90,20 115,35 140,55 165,72 185,85" fill="none" stroke="#ef4444" strokeWidth="2" />

      <text x="148" y="38" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Bear market</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Strategy worked in bull  -  fails in bear. Adapt.</text>

    </svg>

  ),



  l12_c1208_overfitting: (

    <svg viewBox="0 0 200 110" className="w-full">

      <C x={8}  o={72} c={45} h={38} l={74} w={11} />

      <C x={22} o={45} c={60} h={40} l={62} w={11} />

      <C x={36} o={60} c={38} h={34} l={62} w={11} />

      <C x={50} o={38} c={52} h={34} l={54} w={11} />

      <text x="40" y="100" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Past data</text>

      <line x1="80" y1="5" x2="80" y2="105" stroke="#334155" strokeWidth="1" strokeDasharray="3,2" />

      <text x="140" y="32" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Overfitted rules</text>

      <text x="140" y="44" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">fail on new data</text>

      <C x={88} o={55} c={72} h={50} l={74} w={11} />

      <C x={102} o={72} c={58} h={54} l={74} w={11} />

      <C x={116} o={58} c={70} h={55} l={72} w={11} />

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Don't over-optimize  -  keep rules simple</text>

    </svg>

  ),



  l12_c1209_discipline_required: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="12" width="180" height="65" rx="4" fill="#1e293b" stroke="#334155" strokeWidth="1" />

      <text x="100" y="26" fill="#f59e0b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Backtest showed: exit at -₹00</text>

      <text x="100" y="40" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Live trade: loss hits -₹00</text>

      <text x="100" y="54" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">You hold... "it will recover"</text>

      <text x="100" y="66" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Loss becomes -₹,200</text>

      <text x="100" y="72" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Backtest was right  -  you weren't</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Testing without executing the rules is useless</text>

    </svg>

  ),



  l12_c1210_cannot_tell: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="10" width="190" height="68" rx="4" fill="#1e293b" stroke="#ef4444" strokeWidth="1" />

      <text x="100" y="24" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Backtesting cannot tell you:</text>

      <text x="18" y="38" fill="#94a3b8" fontSize="7" textAnchor="start" fontFamily="sans-serif">X How you'll feel during a drawdown</text>

      <text x="18" y="50" fill="#94a3b8" fontSize="7" textAnchor="start" fontFamily="sans-serif">X How news events will affect you</text>

      <text x="18" y="62" fill="#94a3b8" fontSize="7" textAnchor="start" fontFamily="sans-serif">X If you'll follow your own rules live</text>

      <text x="18" y="72" fill="#f59e0b" fontSize="7" textAnchor="start" fontFamily="sans-serif">-> Only live trading reveals that</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Backtest = foundation, not the full picture</text>

    </svg>

  ),



  l12_c1211_testing_to_confidence: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="18" width="36" height="28" rx="3" fill="#1e293b" stroke="#334155" strokeWidth="1" />

      <text x="23" y="34" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Idea</text>

      <line x1="41" y1="32" x2="55" y2="32" stroke="#94a3b8" strokeWidth="1.5" />

      <polygon points="55,32 49,29 49,35" fill="#94a3b8" />

      <rect x="55" y="18" width="36" height="28" rx="3" fill="#1e293b" stroke="#6366F1" strokeWidth="1" />

      <text x="73" y="34" fill="#6366F1" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Backtest</text>

      <line x1="91" y1="32" x2="105" y2="32" stroke="#94a3b8" strokeWidth="1.5" />

      <polygon points="105,32 99,29 99,35" fill="#94a3b8" />

      <rect x="105" y="18" width="36" height="28" rx="3" fill="#1e293b" stroke="#f59e0b" strokeWidth="1" />

      <text x="123" y="34" fill="#f59e0b" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Paper trade</text>

      <line x1="141" y1="32" x2="155" y2="32" stroke="#94a3b8" strokeWidth="1.5" />

      <polygon points="155,32 149,29 149,35" fill="#94a3b8" />

      <rect x="155" y="18" width="40" height="28" rx="3" fill="#16C784" opacity="0.15" stroke="#16C784" strokeWidth="1" />

      <text x="175" y="30" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Live</text>

      <text x="175" y="40" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">trade</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Build confidence step by step</text>

    </svg>

  ),



  l12_c1212_correct_use: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="8" width="190" height="70" rx="4" fill="#1e293b" stroke="#16C784" strokeWidth="1" />

      <text x="100" y="22" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Correct backtesting use:</text>

      <text x="18" y="36" fill="#16C784" fontSize="7" textAnchor="start" fontFamily="sans-serif">OK Test over 50+ trades minimum</text>

      <text x="18" y="48" fill="#16C784" fontSize="7" textAnchor="start" fontFamily="sans-serif">OK Include different market conditions</text>

      <text x="18" y="60" fill="#16C784" fontSize="7" textAnchor="start" fontFamily="sans-serif">OK Measure R:R, not just win rate</text>

      <text x="18" y="72" fill="#ef4444" fontSize="7" textAnchor="start" fontFamily="sans-serif">X Don't curve-fit rules to past data</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Good backtest = honest mirror of your strategy</text>

    </svg>

  ),



  // -- Level 13: Algo Trading ------------------------------------------------



  l13_c1301_algo_what_is: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="12" width="180" height="62" rx="4" fill="#1e293b" stroke="#6366F1" strokeWidth="1.5" />

      <text x="100" y="26" fill="#6366F1" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Algo Trading</text>

      <text x="100" y="40" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">You define rules. Computer executes.</text>

      <text x="100" y="52" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">IF RSI &lt; 30 AND volume &gt; avg -> BUY</text>

      <text x="100" y="64" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">No emotion. No hesitation. Just rules.</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Algo = your rules running automatically</text>

    </svg>

  ),



  l13_c1302_no_edge_dangerous: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="30" y="10" width="140" height="28" rx="3" fill="#1e293b" stroke="#ef4444" strokeWidth="1.5" />

      <text x="100" y="28" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Bad rules -> automated fast</text>

      <line x1="100" y1="38" x2="100" y2="55" stroke="#ef4444" strokeWidth="1.5" />

      <polygon points="100,55 96,49 104,49" fill="#ef4444" />

      <text x="100" y="68" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Losses x speed = disaster</text>

      <text x="100" y="82" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">100 bad trades in 10 minutes</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Automating bad rules makes losses faster</text>

    </svg>

  ),



  l13_c1303_idea_to_auto: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="18" width="30" height="24" rx="2" fill="#1e293b" stroke="#94a3b8" strokeWidth="1" />

      <text x="20" y="32" fill="#94a3b8" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Idea</text>

      <line x1="35" y1="30" x2="48" y2="30" stroke="#94a3b8" strokeWidth="1" />

      <polygon points="48,30 43,27 43,33" fill="#94a3b8" />

      <rect x="48" y="18" width="30" height="24" rx="2" fill="#1e293b" stroke="#6366F1" strokeWidth="1" />

      <text x="63" y="32" fill="#6366F1" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Backtest</text>

      <line x1="78" y1="30" x2="91" y2="30" stroke="#94a3b8" strokeWidth="1" />

      <polygon points="91,30 86,27 86,33" fill="#94a3b8" />

      <rect x="91" y="18" width="30" height="24" rx="2" fill="#1e293b" stroke="#f59e0b" strokeWidth="1" />

      <text x="106" y="32" fill="#f59e0b" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Paper run</text>

      <line x1="121" y1="30" x2="134" y2="30" stroke="#94a3b8" strokeWidth="1" />

      <polygon points="134,30 129,27 129,33" fill="#94a3b8" />

      <rect x="134" y="18" width="30" height="24" rx="2" fill="#1e293b" stroke="#16C784" strokeWidth="1" />

      <text x="149" y="32" fill="#16C784" fontSize="6" textAnchor="middle" fontFamily="sans-serif">Live algo</text>

      <text x="100" y="62" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Each step validates before the next</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Don't skip steps  -  each one earns the next</text>

    </svg>

  ),



  l13_c1304_emotion_not_risk: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <text x="50" y="12" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Removed</text>

      <text x="50" y="28" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Fear of loss OK</text>

      <text x="50" y="40" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Greed OK</text>

      <text x="50" y="52" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Hesitation OK</text>

      <text x="50" y="64" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">FOMO OK</text>

      <text x="150" y="12" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Still present</text>

      <text x="150" y="28" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Market risk X</text>

      <text x="150" y="40" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Bad rules X</text>

      <text x="150" y="52" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Drawdowns X</text>

      <text x="150" y="64" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Tech failures X</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Algo removes emotion  -  not risk</text>

    </svg>

  ),



  l13_c1305_speed_advantage: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="18" width="80" height="50" rx="3" fill="#1e293b" stroke="#94a3b8" strokeWidth="1" />

      <text x="50" y="32" fill="#94a3b8" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Human</text>

      <text x="50" y="46" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">See signal</text>

      <text x="50" y="56" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Decide -> Click</text>

      <text x="50" y="66" fill="#f59e0b" fontSize="7" textAnchor="middle" fontFamily="sans-serif">~3 seconds</text>

      <rect x="110" y="18" width="80" height="50" rx="3" fill="#1e293b" stroke="#16C784" strokeWidth="1" />

      <text x="150" y="32" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Algo</text>

      <text x="150" y="46" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Detect signal</text>

      <text x="150" y="56" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Execute order</text>

      <text x="150" y="66" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">&lt;50ms</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Speed = no slippage, exact entry price</text>

    </svg>

  ),



  l13_c1306_overtrading_risk: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="12" width="180" height="62" rx="4" fill="#1e293b" stroke="#ef4444" strokeWidth="1.5" />

      <text x="100" y="26" fill="#ef4444" fontSize="8" textAnchor="middle" fontFamily="sans-serif">Algo without trade limits:</text>

      <text x="100" y="40" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Fires 40 signals in 1 hour</text>

      <text x="100" y="52" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Each with brokerage + slippage</text>

      <text x="100" y="64" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Costs eat all profits</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Set max trades per day  -  always</text>

    </svg>

  ),



  l13_c1307_limits_cooldown: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="10" width="190" height="68" rx="4" fill="#1e293b" stroke="#f59e0b" strokeWidth="1" />

      <text x="100" y="24" fill="#f59e0b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Algo Guardrails:</text>

      <text x="18" y="38" fill="#16C784" fontSize="7" textAnchor="start" fontFamily="sans-serif">OK Max 3 trades per day</text>

      <text x="18" y="50" fill="#16C784" fontSize="7" textAnchor="start" fontFamily="sans-serif">OK 30 min cooldown after each trade</text>

      <text x="18" y="62" fill="#16C784" fontSize="7" textAnchor="start" fontFamily="sans-serif">OK Stop if daily loss &gt; ₹,000</text>

      <text x="18" y="72" fill="#16C784" fontSize="7" textAnchor="start" fontFamily="sans-serif">OK Only trade 9:30-14:00</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Limits protect you from your own algo</text>

    </svg>

  ),



  l13_c1308_same_diff_results: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <text x="50" y="12" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Bull market</text>

      <polyline points="8,82 30,65 52,48 72,30 88,15" fill="none" stroke="#16C784" strokeWidth="2" />

      <text x="48" y="100" fill="#16C784" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">+₹8,000</text>

      <text x="150" y="12" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Bear market</text>

      <polyline points="108,18 130,35 152,52 172,68 188,82" fill="none" stroke="#ef4444" strokeWidth="2" />

      <text x="150" y="100" fill="#ef4444" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">-₹,000</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="6.5" textAnchor="middle" fontFamily="sans-serif">Same algo  -  different market = different result</text>

    </svg>

  ),



  l13_c1309_monitoring_required: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="30" y="10" width="140" height="28" rx="3" fill="#1e293b" stroke="#6366F1" strokeWidth="1" />

      <text x="100" y="28" fill="#6366F1" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Algo running...</text>

      <line x1="100" y1="38" x2="100" y2="52" stroke="#94a3b8" strokeWidth="1" />

      <text x="100" y="65" fill="#f59e0b" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Check daily:</text>

      <text x="100" y="77" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Is it behaving as expected?</text>

      <text x="100" y="89" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Any unusual trades?</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Set and forget = set and lose</text>

    </svg>

  ),



  l13_c1310_when_not_to_run: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="10" width="190" height="68" rx="4" fill="#1e293b" stroke="#ef4444" strokeWidth="1" />

      <text x="100" y="24" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Pause your algo when:</text>

      <text x="18" y="38" fill="#94a3b8" fontSize="7" textAnchor="start" fontFamily="sans-serif">⚠ Budget/RBI/election announcement</text>

      <text x="18" y="50" fill="#94a3b8" fontSize="7" textAnchor="start" fontFamily="sans-serif">⚠ Extreme market volatility (VIX spike)</text>

      <text x="18" y="62" fill="#94a3b8" fontSize="7" textAnchor="start" fontFamily="sans-serif">⚠ Algo behaving unexpectedly</text>

      <text x="18" y="72" fill="#94a3b8" fontSize="7" textAnchor="start" fontFamily="sans-serif">⚠ You don't understand why it traded</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Knowing when NOT to run is part of the system</text>

    </svg>

  ),



  l13_c1311_discipline_auto: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="10" y="18" width="80" height="55" rx="3" fill="#1e293b" stroke="#ef4444" strokeWidth="1" />

      <text x="50" y="32" fill="#ef4444" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Manual trading</text>

      <text x="50" y="46" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Move SL: yes</text>

      <text x="50" y="58" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Skip signal: yes</text>

      <text x="50" y="68" fill="#ef4444" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Discipline: hard</text>

      <rect x="110" y="18" width="80" height="55" rx="3" fill="#1e293b" stroke="#16C784" strokeWidth="1" />

      <text x="150" y="32" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Algo trading</text>

      <text x="150" y="46" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Move SL: no</text>

      <text x="150" y="58" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Skip signal: no</text>

      <text x="150" y="68" fill="#16C784" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Rules: enforced</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Automation enforces the discipline you struggle with</text>

    </svg>

  ),



  l13_c1312_system_flow: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="5" y="8" width="190" height="75" rx="4" fill="#1e293b" stroke="#16C784" strokeWidth="1.5" />

      <text x="100" y="22" fill="#16C784" fontSize="7.5" textAnchor="middle" fontFamily="sans-serif">Complete Algo System:</text>

      <text x="18" y="36" fill="#6366F1" fontSize="7" textAnchor="start" fontFamily="sans-serif">1. Strategy -> Backtest -> Validate</text>

      <text x="18" y="48" fill="#f59e0b" fontSize="7" textAnchor="start" fontFamily="sans-serif">2. Paper trade -> Confirm behavior</text>

      <text x="18" y="60" fill="#16C784" fontSize="7" textAnchor="start" fontFamily="sans-serif">3. Live with small capital + limits</text>

      <text x="18" y="72" fill="#94a3b8" fontSize="7" textAnchor="start" fontFamily="sans-serif">4. Monitor daily -> Adjust when needed</text>

      <text x="100" y="105" fill="#94a3b8" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Build -> Test -> Run -> Monitor -> Improve</text>

    </svg>

  ),

};

